import type { Session } from '@change/core/session';

export function isGuest(session: Session) {
	return session.loginState === 'GUEST';
}
